import { useTranslation } from "react-i18next";

import { useJsonApi } from "@/modules/api/hooks/useJsonApi";
import { useMutation } from "@/modules/api/hooks/useMutation";
import { apiErrorValidate } from "@/modules/api/utils/apiErrorValidate";
import { signInMutation } from "@/modules/auth/api/mutations/signIn/signInMutation";

import { acknowledgeLevelMutation } from "../api/mutations/acknowledgeLevelMutation";

const translationNamespace = "apiMessages/useAcknowledgeLevelMutation";

export const useAcknowledgeLevelMutation = () => {
  const jsonApi = useJsonApi();
  const { t } = useTranslation(translationNamespace);

  return useMutation([signInMutation.name], {
    mutationFn: acknowledgeLevelMutation(jsonApi),
    onSuccess: () => {
      return;
    },
    onError: (error) => {
      apiErrorValidate(error, {
        400: {
          BAD_REQUEST: t("Something went wrong, try again later"),
        },
        401: {
          UNAUTHORIZED: t(
            "You are not allowed to acknowledge the level. Please sign in again"
          ),
        },
        403: {
          FORBIDDEN: t("You don't have an access to acknowledge the level"),
        },
        404: {
          LEVEL_NOT_FOUND: t("The level cannot be found"),
        },
        422: {
          LEVEL_NOT_ACHIEVED: t(
            "The level hasn't been achieved. Please refresh the app"
          ),
        },
      });
    },
    retry: false,
  });
};
